import * as yup from "yup"

export const newOperator = yup.object().shape({
  nombre: yup.string().required("Este campo es requerido"),
  ubicacion_id: yup.string().required("Este campo es requerido"),
})
